// src/hooks/useDevicesDataList.ts

import { useEffect, useState } from "react";
import http from "services/httpClient";
// import authApi from "services/authApi";

export interface DeviceDataItem {
  id: number;
  device_name: string;
  client_id: number;
  client_name: string;
  mount_point: string;
  conn: number;
  param_count: number;
  date_created: string;
}

export const useDevicesDataList = (refreshKey: number) => {
  const [devices, setDevices] = useState<DeviceDataItem[]>([]);

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        // Poll in main devices tab
        const res = await http.get<DeviceDataItem[]>(`/device?sort_by=device`, {
        });
        setDevices(res.data);
      } catch (err) {
        // console.error("Failed to load devices:", err);
      }
    };

    fetchDevices();
  }, [refreshKey]);

  return devices;
};

export default useDevicesDataList;
